import {FamilyIcon, GreenAreasIcon, PercentIcon, PoiBusIcon, PoiSubwayIcon, PoiTrainIcon, PoiTramIcon} from "@pg-design/icons-module";

/**
 * Maps a USP `icon` key (from the API/mock/POI config) to a concrete icon component.
 * Unknown keys render no icon (see OfferBoxUspChip).
 */
type UspIconComponent = typeof PercentIcon;

export const offerUspIcons: Record<string, UspIconComponent> = {
    percent: PercentIcon,
    family: FamilyIcon,
    train: PoiTrainIcon,
    bus: PoiBusIcon,
    tram: PoiTramIcon,
    park: GreenAreasIcon,
    forest: GreenAreasIcon,
    "nature-reserve": GreenAreasIcon,
    kolej: PoiTrainIcon,
    metro: PoiSubwayIcon
};
import {FamilyIcon, GreenAreasIcon, PercentIcon, PoiBusIcon, PoiSubwayIcon, PoiTrainIcon, PoiTramIcon} from "@pg-design/icons-module";

/**
 * Maps a USP `icon` key (from the API/mock/POI config) to a concrete icon component.
 * Unknown keys render no icon (see OfferBoxUspChip).
 */
type UspIconComponent = typeof PercentIcon;

export const offerUspIcons: Record<string, UspIconComponent> = {
    percent: PercentIcon,
    family: FamilyIcon,
    train: PoiTrainIcon,
    bus: PoiBusIcon,
    tram: PoiTramIcon,
    park: GreenAreasIcon,
    forest: GreenAreasIcon,
    "nature-reserve": GreenAreasIcon,
    kolej: PoiTrainIcon,
    metro: PoiSubwayIcon
};
